import { useState } from 'react'
import { useSelector } from 'react-redux'
import { PricingSummary } from './pricing-summary'
import { ProbateCase } from 'lib/models/probate-case'
import { ProbateQuoteHistory } from 'lib/models/probate-quote-history'
import { findCaseBookedInvoice } from 'utils/helpers'
import { RESOURCES, useFetchArrayResource } from 'api'
import { Invoice } from 'lib/models/invoice'
import { Wrapper } from '@farewill/ui'
import { Lead } from 'lib/models/lead'

export const Pricing = () => {
  const probateCase = useSelector(
    (state: { probateCase: ProbateCase }) => state.probateCase
  )
  const lead = useSelector((state: { lead: Lead }) => state.lead)
  const { data: { data: quoteHistory = [] } = {}, isLoading: isLoadingQuotes } =
    useFetchArrayResource<ProbateQuoteHistory>(
      {
        resource: RESOURCES.PROBATE_QUOTE_HISTORY,
        endpoint: `/api/probate-cases/${probateCase.id}/quote-history`,
        queryKey: [RESOURCES.PROBATE_QUOTE_HISTORY, probateCase.id],
      },
      { enabled: !!probateCase.id }
    )

  const { data: { data: invoices = [] } = {}, isLoading: isLoadingInvoices } =
    useFetchArrayResource<Invoice>(
      {
        resource: RESOURCES.INVOICES,
        params: `filter[probateCaseId]=${probateCase.id}`,
      },
      { enabled: !!probateCase.id }
    )
  const [selectedQuoteIndex, setSelectedQuoteIndex] = useState<
    number | undefined
  >()

  if (isLoadingQuotes || isLoadingInvoices) {
    return <p>Loading booking details…</p>
  }

  const latestQuoteIndex = quoteHistory?.length - 1
  const latestQuote = quoteHistory[latestQuoteIndex]

  if (!latestQuote) {
    return null
  }

  const caseBookedInvoice = findCaseBookedInvoice(invoices)

  return caseBookedInvoice ? (
    <Wrapper>
      <PricingSummary
        availableVouchers={lead.attributes.availableVouchers || []}
        quoteHistory={quoteHistory}
        selectedQuoteIndex={selectedQuoteIndex ?? latestQuoteIndex}
        onSelectedQuoteIndexChange={setSelectedQuoteIndex}
      />
    </Wrapper>
  ) : null
}
